import React, { createContext, useContext, useMemo } from 'react';

import type { ConfigUrls } from 'hb-react/frontoffice/apps/Forum/types';
import type { AppPageConfig } from 'hb-react/types';

type Context = Omit<ForumProviderProps, 'children'>;

const ForumContext = createContext<Context>({
  configUrls: {
    indexUrl: () => '',
    discussionUrl: () => '',
    editDiscussionUrl: () => '',
    newDiscussionUrl: () => '',
    getCategoriesPath: () => '',
    getDiscussionsPath: () => '',
    createDiscussionPath: () => '',
    getDiscussionPath: () => '',
    getEditDiscussionPath: () => '',
    updateDiscussionPath: () => '',
    deleteDiscussionPath: () => '',
    followDiscussionPath: () => '',
    getWidgetsPath: () => '',
  },
  // @ts-expect-error not initialized
  appPageConfig: {},
});

export const useForumContext = () => {
  const context = useContext(ForumContext);

  if (!context) {
    throw new Error('useForumContext must be used within a ForumProvider');
  }

  return context;
};

interface ForumProviderProps {
  children: React.ReactNode;
  configUrls: ConfigUrls;
  appPageConfig: AppPageConfig;
  topicName?: string;
}

export const ForumProvider = ({
  children,
  configUrls,
  appPageConfig,
  topicName,
}: ForumProviderProps) => {
  const providerState = useMemo(
    () => ({
      appPageConfig,
      configUrls,
      topicName,
    }),
    [appPageConfig, configUrls, topicName],
  );

  return (
    <ForumContext.Provider value={providerState}>
      {children}
    </ForumContext.Provider>
  );
};

export default ForumContext;
